import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import VRFSystemDetail from '../../components/vrf/VRFSystemDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createVRFSystem } from '../../redux/vrf/vrf_system_actions';

class VRFSystemCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
      itemsDirty: false,
    };
    this.detail = undefined;
  }

  // UAT feedback 9/10/2569: เดิมปุ่ม Save ขึ้นกับ dirty ของ Form (ชื่อ/คำอธิบาย) อย่างเดียว
  // → แก้แค่ outdoor/indoor แล้วกด Save ไม่ได้ ปิด modal ข้อมูลที่เลือกไว้หายเพราะไม่เคยถูกบันทึก
  canSave() {
    const { isDirty, isSubmittable, itemsDirty } = this.state;
    return isDirty ? isSubmittable : itemsDirty;
  }

  onSaveHandler() {
    const detail = this.detail.getWrappedInstance().getWrappedInstance();
    if (!detail.validate()) return;
    const data = detail.getData();
    this.props.create(data);
  }

  render() {
    const { isCreating, errorMessage, create, t, ...newProps } = this.props;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
        onEnter={() =>
          this.setState({
            isDirty: false,
            isSubmittable: false,
            itemsDirty: false,
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create vrf system')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VRFSystemDetail
            ref={ref => (this.detail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onItemsDirty={itemsDirty => this.setState({ itemsDirty })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="vrf-system-submit-create"
            disabled={!this.canSave() || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.vrfSystem.errorMessage,
  isCreating: state.vrfSystem.isCreating,
});

const mapDispatchToProps = dispatch => ({
  create: data => defaultRejectHandler(dispatch(createVRFSystem(data))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(VRFSystemCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/vrf/VRFSystemCreateModal.js